import {
  SortDirections,
  SortKeys,
  SortValue,
  ValidSortingOptions,
  VendorSearchRequest,
} from '~/pages/couples/explore/components/SearchResults/types/types';
import { OptionFacetCategoryType } from '~/types/types';

import {
  getSortingLabel,
  isSortDirection,
  isSortKey,
  sortingByVendorType,
  sortValueToString,
} from '../../utils/sortHelpers';

type VendorSortingOptions = ValidSortingOptions & {
  value: SortValue;
};

const createVendorSortingOptions = (arr: ValidSortingOptions[]): VendorSortingOptions[] => {
  return arr.map((option) => {
    if (option.sortBy === null) {
      return {
        ...option,
        value: 'DEFAULT',
      };
    } else {
      return {
        ...option,
        value: sortValueToString({ sortBy: option.sortBy, sortOrder: option.sortOrder }),
      };
    }
  });
};

/**
 * Creates a sorting category to be displayed in the SRP filters bar.
 * The display name of the filter chip should be the selected sorting type
 */
export const createManualSortingFilter = (
  vendorSearch: VendorSearchRequest | null | undefined
): OptionFacetCategoryType => {
  const currentSortingOption = vendorSearchSortingToString(vendorSearch);
  const sortingOptions = createVendorSortingOptions(
    sortingByVendorType(
      vendorSearch?.selectedTaxonomy?.key,
      vendorSearch?.selectedLocation,
      vendorSearch?.searchName
    )
  );

  return {
    displayName: `Sort: ${getSortingLabel(vendorSearch?.searchName, currentSortingOption)}`,
    key: 'sorting',
    slug: currentSortingOption,
    facets: sortingOptions.map((option) => ({
      displayName: option.label,
      key: option.value,
      slug: option.value,
    })),
  };
};

/** Tries to parse a string for the sort key and direction, if they are invalid, returns the default */
export function parseSortingValues(value: string): [SortKeys, SortDirections] | [null, null] {
  const [sortBy, sortOrder] = value.split('|');
  if (isSortKey(sortBy) && isSortDirection(sortOrder)) {
    return [sortBy, sortOrder];
  }
  return [null, null];
}

/** Converts the vendor search sorting option to a string */
export function vendorSearchSortingToString(
  vendorSearch: VendorSearchRequest | null | undefined
): SortValue {
  return vendorSearch?.sorting ? sortValueToString(vendorSearch.sorting) : 'DEFAULT';
}
